/**
 * Timezone options shared across the portal.
 * Includes Windows timezone IDs and UTC offset-based IDs (e.g., "UTC-08").
 * .NET 8 supports both on Linux via ICU.
 */
export const timeZones = [
  {
    value: 'Dateline Standard Time',
    displayName: '(UTC-12:00) International Date Line West',
  },
  {
    value: 'UTC-11',
    displayName: '(UTC-11:00) Coordinated Universal Time-11',
  },
  {
    value: 'Aleutian Standard Time',
    displayName: '(UTC-10:00) Aleutian Islands',
  },
  {
    value: 'Hawaiian Standard Time',
    displayName: '(UTC-10:00) Hawaii',
  },
  {
    value: 'Marquesas Standard Time',
    displayName: '(UTC-09:30) Marquesas Islands',
  },
  {
    value: 'Alaskan Standard Time',
    displayName: '(UTC-09:00) Alaska',
  },
  {
    value: 'UTC-09',
    displayName: '(UTC-09:00) Coordinated Universal Time-09',
  },
  {
    value: 'Pacific Standard Time (Mexico)',
    displayName: '(UTC-08:00) Baja California',
  },
  {
    value: 'UTC-08',
    displayName: '(UTC-08:00) Coordinated Universal Time-08',
  },
  {
    value: 'Pacific Standard Time',
    displayName: '(UTC-08:00) Pacific Time (US & Canada)',
  },
  {
    value: 'US Mountain Standard Time',
    displayName: '(UTC-07:00) Arizona',
  },
  {
    value: 'Mountain Standard Time (Mexico)',
    displayName: '(UTC-07:00) Chihuahua, La Paz, Mazatlan',
  },
  {
    value: 'Mountain Standard Time',
    displayName: '(UTC-07:00) Mountain Time (US & Canada)',
  },
  {
    value: 'Central America Standard Time',
    displayName: '(UTC-06:00) Central America',
  },
  {
    value: 'Central Standard Time',
    displayName: '(UTC-06:00) Central Time (US & Canada)',
  },
  {
    value: 'Easter Island Standard Time',
    displayName: '(UTC-06:00) Easter Island',
  },
  {
    value: 'Central Standard Time (Mexico)',
    displayName: '(UTC-06:00) Guadalajara, Mexico City, Monterrey',
  },
  {
    value: 'Canada Central Standard Time',
    displayName: '(UTC-06:00) Saskatchewan',
  },
  {
    value: 'SA Pacific Standard Time',
    displayName: '(UTC-05:00) Bogota, Lima, Quito, Rio Branco',
  },
  {
    value: 'Eastern Standard Time (Mexico)',
    displayName: '(UTC-05:00) Chetumal',
  },
  {
    value: 'Eastern Standard Time',
    displayName: '(UTC-05:00) Eastern Time (US & Canada)',
  },
  {
    value: 'Haiti Standard Time',
    displayName: '(UTC-05:00) Haiti',
  },
  {
    value: 'Cuba Standard Time',
    displayName: '(UTC-05:00) Havana',
  },
  {
    value: 'US Eastern Standard Time',
    displayName: '(UTC-05:00) Indiana (East)',
  },
  {
    value: 'Paraguay Standard Time',
    displayName: '(UTC-04:00) Asuncion',
  },
  {
    value: 'Atlantic Standard Time',
    displayName: '(UTC-04:00) Atlantic Time (Canada)',
  },
  {
    value: 'Venezuela Standard Time',
    displayName: '(UTC-04:00) Caracas',
  },
  {
    value: 'Central Brazilian Standard Time',
    displayName: '(UTC-04:00) Cuiaba',
  },
  {
    value: 'SA Western Standard Time',
    displayName: '(UTC-04:00) Georgetown, La Paz, Manaus, San Juan',
  },
  {
    value: 'Pacific SA Standard Time',
    displayName: '(UTC-04:00) Santiago',
  },
  {
    value: 'Turks And Caicos Standard Time',
    displayName: '(UTC-04:00) Turks and Caicos',
  },
  {
    value: 'Newfoundland Standard Time',
    displayName: '(UTC-03:30) Newfoundland',
  },
  {
    value: 'Tocantins Standard Time',
    displayName: '(UTC-03:00) Araguaina',
  },
  {
    value: 'E. South America Standard Time',
    displayName: '(UTC-03:00) Brasilia',
  },
  {
    value: 'SA Eastern Standard Time',
    displayName: '(UTC-03:00) Cayenne, Fortaleza',
  },
  {
    value: 'Argentina Standard Time',
    displayName: '(UTC-03:00) City of Buenos Aires',
  },
  {
    value: 'Greenland Standard Time',
    displayName: '(UTC-03:00) Greenland',
  },
  {
    value: 'Montevideo Standard Time',
    displayName: '(UTC-03:00) Montevideo',
  },
  {
    value: 'Saint Pierre Standard Time',
    displayName: '(UTC-03:00) Saint Pierre and Miquelon',
  },
  {
    value: 'Bahia Standard Time',
    displayName: '(UTC-03:00) Salvador',
  },
  {
    value: 'UTC-02',
    displayName: '(UTC-02:00) Coordinated Universal Time-02',
  },
  {
    value: 'Mid-Atlantic Standard Time',
    displayName: '(UTC-02:00) Mid-Atlantic - Old',
  },
  {
    value: 'Azores Standard Time',
    displayName: '(UTC-01:00) Azores',
  },
  {
    value: 'Cape Verde Standard Time',
    displayName: '(UTC-01:00) Cabo Verde Is.',
  },
  {
    value: 'UTC',
    displayName: '(UTC) Coordinated Universal Time',
  },
  {
    value: 'Morocco Standard Time',
    displayName: '(UTC+00:00) Casablanca',
  },
  {
    value: 'GMT Standard Time',
    displayName: '(UTC+00:00) Dublin, Edinburgh, Lisbon, London',
  },
  {
    value: 'Greenwich Standard Time',
    displayName: '(UTC+00:00) Monrovia, Reykjavik',
  },
  {
    value: 'W. Europe Standard Time',
    displayName: '(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna',
  },
  {
    value: 'Central Europe Standard Time',
    displayName: '(UTC+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague',
  },
  {
    value: 'Romance Standard Time',
    displayName: '(UTC+01:00) Brussels, Copenhagen, Madrid, Paris',
  },
  {
    value: 'Central European Standard Time',
    displayName: '(UTC+01:00) Sarajevo, Skopje, Warsaw, Zagreb',
  },
  {
    value: 'W. Central Africa Standard Time',
    displayName: '(UTC+01:00) West Central Africa',
  },
  {
    value: 'Namibia Standard Time',
    displayName: '(UTC+01:00) Windhoek',
  },
  {
    value: 'Jordan Standard Time',
    displayName: '(UTC+02:00) Amman',
  },
  {
    value: 'GTB Standard Time',
    displayName: '(UTC+02:00) Athens, Bucharest',
  },
  {
    value: 'Middle East Standard Time',
    displayName: '(UTC+02:00) Beirut',
  },
  {
    value: 'Egypt Standard Time',
    displayName: '(UTC+02:00) Cairo',
  },
  {
    value: 'E. Europe Standard Time',
    displayName: '(UTC+02:00) Chisinau',
  },
  {
    value: 'Syria Standard Time',
    displayName: '(UTC+02:00) Damascus',
  },
  {
    value: 'West Bank Standard Time',
    displayName: '(UTC+02:00) Gaza, Hebron',
  },
  {
    value: 'South Africa Standard Time',
    displayName: '(UTC+02:00) Harare, Pretoria',
  },
  {
    value: 'FLE Standard Time',
    displayName: '(UTC+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius',
  },
  {
    value: 'Turkey Standard Time',
    displayName: '(UTC+02:00) Istanbul',
  },
  {
    value: 'Israel Standard Time',
    displayName: '(UTC+02:00) Jerusalem',
  },
  {
    value: 'Kaliningrad Standard Time',
    displayName: '(UTC+02:00) Kaliningrad',
  },
  {
    value: 'Libya Standard Time',
    displayName: '(UTC+02:00) Tripoli',
  },
  {
    value: 'Arabic Standard Time',
    displayName: '(UTC+03:00) Baghdad',
  },
  {
    value: 'Arab Standard Time',
    displayName: '(UTC+03:00) Kuwait, Riyadh',
  },
  {
    value: 'Belarus Standard Time',
    displayName: '(UTC+03:00) Minsk',
  },
  {
    value: 'Russian Standard Time',
    displayName: '(UTC+03:00) Moscow, St. Petersburg, Volgograd',
  },
  {
    value: 'E. Africa Standard Time',
    displayName: '(UTC+03:00) Nairobi',
  },
  {
    value: 'Iran Standard Time',
    displayName: '(UTC+03:30) Tehran',
  },
  {
    value: 'Arabian Standard Time',
    displayName: '(UTC+04:00) Abu Dhabi, Muscat',
  },
  {
    value: 'Astrakhan Standard Time',
    displayName: '(UTC+04:00) Astrakhan, Ulyanovsk',
  },
  {
    value: 'Azerbaijan Standard Time',
    displayName: '(UTC+04:00) Baku',
  },
  {
    value: 'Russia Time Zone 3',
    displayName: '(UTC+04:00) Izhevsk, Samara',
  },
  {
    value: 'Mauritius Standard Time',
    displayName: '(UTC+04:00) Port Louis',
  },
  {
    value: 'Georgian Standard Time',
    displayName: '(UTC+04:00) Tbilisi',
  },
  {
    value: 'Caucasus Standard Time',
    displayName: '(UTC+04:00) Yerevan',
  },
  {
    value: 'Afghanistan Standard Time',
    displayName: '(UTC+04:30) Kabul',
  },
  {
    value: 'West Asia Standard Time',
    displayName: '(UTC+05:00) Ashgabat, Tashkent',
  },
  {
    value: 'Ekaterinburg Standard Time',
    displayName: '(UTC+05:00) Ekaterinburg',
  },
  {
    value: 'Pakistan Standard Time',
    displayName: '(UTC+05:00) Islamabad, Karachi',
  },
  {
    value: 'India Standard Time',
    displayName: '(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi',
  },
  {
    value: 'Sri Lanka Standard Time',
    displayName: '(UTC+05:30) Sri Jayawardenepura',
  },
  {
    value: 'Nepal Standard Time',
    displayName: '(UTC+05:45) Kathmandu',
  },
  {
    value: 'Central Asia Standard Time',
    displayName: '(UTC+06:00) Astana',
  },
  {
    value: 'Bangladesh Standard Time',
    displayName: '(UTC+06:00) Dhaka',
  },
  {
    value: 'N. Central Asia Standard Time',
    displayName: '(UTC+06:00) Novosibirsk',
  },
  {
    value: 'Myanmar Standard Time',
    displayName: '(UTC+06:30) Yangon (Rangoon)',
  },
  {
    value: 'SE Asia Standard Time',
    displayName: '(UTC+07:00) Bangkok, Hanoi, Jakarta',
  },
  {
    value: 'Altai Standard Time',
    displayName: '(UTC+07:00) Barnaul, Gorno-Altaysk',
  },
  {
    value: 'W. Mongolia Standard Time',
    displayName: '(UTC+07:00) Hovd',
  },
  {
    value: 'North Asia Standard Time',
    displayName: '(UTC+07:00) Krasnoyarsk',
  },
  {
    value: 'Tomsk Standard Time',
    displayName: '(UTC+07:00) Tomsk',
  },
  {
    value: 'China Standard Time',
    displayName: '(UTC+08:00) Beijing, Chongqing, Hong Kong, Urumqi',
  },
  {
    value: 'North Asia East Standard Time',
    displayName: '(UTC+08:00) Irkutsk',
  },
  {
    value: 'Singapore Standard Time',
    displayName: '(UTC+08:00) Kuala Lumpur, Singapore',
  },
  {
    value: 'W. Australia Standard Time',
    displayName: '(UTC+08:00) Perth',
  },
  {
    value: 'Taipei Standard Time',
    displayName: '(UTC+08:00) Taipei',
  },
  {
    value: 'Ulaanbaatar Standard Time',
    displayName: '(UTC+08:00) Ulaanbaatar',
  },
  {
    value: 'North Korea Standard Time',
    displayName: '(UTC+08:30) Pyongyang',
  },
  {
    value: 'Aus Central W. Standard Time',
    displayName: '(UTC+08:45) Eucla',
  },
  {
    value: 'Transbaikal Standard Time',
    displayName: '(UTC+09:00) Chita',
  },
  {
    value: 'Tokyo Standard Time',
    displayName: '(UTC+09:00) Osaka, Sapporo, Tokyo',
  },
  {
    value: 'Korea Standard Time',
    displayName: '(UTC+09:00) Seoul',
  },
  {
    value: 'Yakutsk Standard Time',
    displayName: '(UTC+09:00) Yakutsk',
  },
  {
    value: 'Cen. Australia Standard Time',
    displayName: '(UTC+09:30) Adelaide',
  },
  {
    value: 'AUS Central Standard Time',
    displayName: '(UTC+09:30) Darwin',
  },
  {
    value: 'E. Australia Standard Time',
    displayName: '(UTC+10:00) Brisbane',
  },
  {
    value: 'AUS Eastern Standard Time',
    displayName: '(UTC+10:00) Canberra, Melbourne, Sydney',
  },
  {
    value: 'West Pacific Standard Time',
    displayName: '(UTC+10:00) Guam, Port Moresby',
  },
  {
    value: 'Tasmania Standard Time',
    displayName: '(UTC+10:00) Hobart',
  },
  {
    value: 'Vladivostok Standard Time',
    displayName: '(UTC+10:00) Vladivostok',
  },
  {
    value: 'Lord Howe Standard Time',
    displayName: '(UTC+10:30) Lord Howe Island',
  },
  {
    value: 'Bougainville Standard Time',
    displayName: '(UTC+11:00) Bougainville Island',
  },
  {
    value: 'Russia Time Zone 10',
    displayName: '(UTC+11:00) Chokurdakh',
  },
  {
    value: 'Magadan Standard Time',
    displayName: '(UTC+11:00) Magadan',
  },
  {
    value: 'Norfolk Standard Time',
    displayName: '(UTC+11:00) Norfolk Island',
  },
  {
    value: 'Sakhalin Standard Time',
    displayName: '(UTC+11:00) Sakhalin',
  },
  {
    value: 'Central Pacific Standard Time',
    displayName: '(UTC+11:00) Solomon Is., New Caledonia',
  },
  {
    value: 'Russia Time Zone 11',
    displayName: '(UTC+12:00) Anadyr, Petropavlovsk-Kamchatsky',
  },
  {
    value: 'New Zealand Standard Time',
    displayName: '(UTC+12:00) Auckland, Wellington',
  },
  {
    value: 'UTC+12',
    displayName: '(UTC+12:00) Coordinated Universal Time+12',
  },
  {
    value: 'Fiji Standard Time',
    displayName: '(UTC+12:00) Fiji',
  },
  {
    value: 'Kamchatka Standard Time',
    displayName: '(UTC+12:00) Petropavlovsk-Kamchatsky - Old',
  },
  {
    value: 'Chatham Islands Standard Time',
    displayName: '(UTC+12:45) Chatham Islands',
  },
  {
    value: 'Tonga Standard Time',
    displayName: "(UTC+13:00) Nuku'alofa",
  },
  {
    value: 'Samoa Standard Time',
    displayName: '(UTC+13:00) Samoa',
  },
  {
    value: 'Line Islands Standard Time',
    displayName: '(UTC+14:00) Kiritimati Island',
  },
];
